
<template>
  <v-container>
    <!-- Abas -->
    <v-tabs
        v-model="tab"
        background-color="grey lighten-4"
        grow
        show-arrows
        class="custom-tabs"
        slider-color="blue darken-2"
    >
      <v-tab v-for="(item, index) in tabs" :key="index" class="custom-tab">
        {{ item.label }}
      </v-tab>
    </v-tabs>

    <!-- Conteúdo -->
    <v-tabs-items v-model="tab">
      <v-tab-item v-for="(item, index) in tabs" :key="index">
        <component :is="item.component" :key="tab" />
      </v-tab-item>
    </v-tabs-items>
  </v-container>
</template>

<script>

import GreComponent from './views/ManterDasboardFormacaoGreView.vue';
import EscolasComponent from './views/Escolas/ManterDashboardFormacaoEscolasView.vue';
import SeeComponent from './views/SEE/ManterDashboardFormacaoSEEView.vue';

export default {
  name: "ManterDashboardFormacaoView",
  mixins: [],
  components: {
  },
  data: () => ({
    tab: 0,
    tabs: [
      { label: 'GRE', component: GreComponent },
      { label: 'ESCOLA', component: EscolasComponent },
      { label: 'SEE', component: SeeComponent},
    ],
  }),
}
</script>

<style scoped>
  .custom-tabs {
    margin-bottom: 20px;
  }

  .custom-tab {
    font-weight: bold;
    text-transform: none;
    transition: color 0.3s;
  }

  .custom-tab:hover {
    color: #1a73e8 !important;
  }
</style>